import quickFetch from 'quick-fetch';
const gateName = 'hs-resources:FullSearchRPC';
let cachedResult;
export const __TEST_ONLY_setSearchRpcGate = value => {
  cachedResult = Promise.resolve(value === 'true');
};
export const __TEST_ONLY_resetSearchRpcGate = () => {
  cachedResult = undefined;
};
const checkSearchRpcGate = () => new Promise(resolve => {
  if (!quickFetch.getLoginVerifyRequest()) {
    resolve(false);
    return;
  }
  const safetyTimeout = setTimeout(() => resolve(false), 1000);
  quickFetch.afterAuth(auth => {
    var _auth$portal$enabled_, _auth$portal$enabled_2;
    clearTimeout(safetyTimeout);
    resolve((_auth$portal$enabled_ = (_auth$portal$enabled_2 = auth.portal.enabled_v3_gates) === null || _auth$portal$enabled_2 === void 0 ? void 0 : _auth$portal$enabled_2.includes(gateName)) !== null && _auth$portal$enabled_ !== void 0 ? _auth$portal$enabled_ : false);
  });
});
export const isSearchRpcGateEnabled = () => {
  var _cachedResult;
  cachedResult = (_cachedResult = cachedResult) !== null && _cachedResult !== void 0 ? _cachedResult : checkSearchRpcGate();
  return cachedResult;
};